import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const GoodDaysPage = () => {
  const [data, setData] = useState([]);
  const [eventType, setEventType] = useState('all');

  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json').then(r => {
      const now = new Date(); now.setHours(0,0,0,0);
      const good = r.data.filter(d => {
        if (!d.EnglishDate) return false;
        const p = d.EnglishDate.split('/');
        const dt = new Date(parseInt(p[2]),parseInt(p[0])-1,parseInt(p[1]));
        if (dt < now) return false;
        // Filter only good days (no rahu/yama issues, good thithi+star combos)
        const badThithi = ['அமாவாசை','அஷ்டமி','நவமி','சதுர்த்தி','சஷ்டி','சதுர்தசி'];
        if (badThithi.some(t => d.ThithiNameInTamil?.includes(t))) return false;
        return true;
      });
      setData(good.slice(0, 60));
    }).catch(() => {});
  }, []);

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>✨ நல்ல நாட்கள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Upcoming Good Days</div>
      </div>
      <div style={{fontSize:'0.7rem',color:T.greenDk,fontWeight:700,marginBottom:'6px'}}>📊 {data.length} upcoming good days (bad thithis excluded)</div>
      {data.map((d,i) => (
        <div key={i} style={{background:T.cream,padding:'6px 8px',borderRadius:'4px',marginBottom:'2px',border:'1px solid '+T.border,fontSize:'0.7rem'}}>
          <b style={{color:T.greenDk}}>{d.EnglishDate}</b> {d.DayNameInTamil} | {d.ThithiNameInTamil} | {d.NakshatraNameInTamil}
          {d.DaySpecialityInTamil && <span style={{color:T.orange}}> ⭐{d.DaySpecialityInTamil}</span>}
        </div>
      ))}
    </div>
  );
};
export default GoodDaysPage;